import PageNotFound from "@tw/purchase-cra/lib/components/common/page-not-found/page-not-found-master-nextjs";
import PageWrapper from "../wrappers/page-wrapper";

PageNotFound.domainName = "page-not-found";

export default PageWrapper(PageNotFound);
